var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.className},_vm.listeners),[_vm._t("default"),(_vm.closable)?_c('Icon',{staticClass:"hive-tag__close",attrs:{"icon":"clear"},on:{"click":_vm.onClose}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }